<div class="my-3 my-md-5">
    <div class="container">
        <div class="page-header">
            <h1 class="page-title">
                <span *ngIf="!planId">Add Plan Package</span>
                <span *ngIf="planId">Update Plan Package</span>
            </h1>
        </div>
        <div class="card">
            <form [formGroup]="planPackageForm" (submit)="createPlanPackage()">
                <div class="card-body">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Plan Name*</label>
                                    <input type="text" placeholder="Plan Name" formControlName="plan_name"
                                        class="form-control" />
                                    <div *ngIf="submitted && f.plan_name.errors" class="invalid-feedback">
                                        <div *ngIf="f.plan_name.errors.required">Plan Name is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Plan Amount</label>
                                    <input type="text" placeholder="Plan Amount" formControlName="plan_amount"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Plan Mrp Amount</label>
                                    <input type="text" placeholder="Plan Mrp Amount" formControlName="plan_mrp_amount"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Plan Amount For Member</label>
                                    <input type="text" placeholder="Plan Amount For Member"
                                        formControlName="plan_amount_for_member" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Status*</label>
                                    <mat-select placeholder="Status" formControlName="status">
                                        <mat-option [value]="1">Active</mat-option>
                                        <mat-option [value]="0">In-Active</mat-option>
                                    </mat-select>
                                    <div *ngIf="submitted && f.status.errors" class="invalid-feedback">
                                        <div *ngIf="f.status.errors.required">Status is required</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Test Name Availed</label>
                                    <mat-select placeholder="Test Name Availed" formControlName="test_name_availed">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Online Gp</label>
                                    <mat-select placeholder="Online Gp" formControlName="online_gp">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Online Surgeon</label>
                                    <mat-select placeholder="Online Surgeon" formControlName="online_surgeon">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Online Dentists</label>
                                    <mat-select placeholder="Online Dentists" formControlName="online_dentists">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Surgeon Opd</label>
                                    <mat-select placeholder="Surgeon Opd" formControlName="surgeon_opd">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Dentist Opd</label>
                                    <mat-select placeholder="Dentist Opd" formControlName="dentist_opd">
                                        <mat-option [value]="1">Yes</mat-option>
                                        <mat-option [value]="2">No</mat-option>
                                    </mat-select>
                                </div>
                            </div>

                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Tests (discount %)</label>
                                    <input type="text" placeholder="Tests (discount %)" formControlName="tests_discount"
                                        class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-3 col-lg-3">
                                <div class="form-group">
                                    <label class="form-label">Aligners (discount %)</label>
                                    <input type="text" placeholder="Aligners (discount %)"
                                        formControlName="aligners_discount" class="form-control" />
                                </div>
                            </div>
                            <div class="col-md-4 col-lg-4">
                                <div class="form-group">
                                    <label class="form-label">Description</label>
                                    <ckeditor [editor]="Editor" formControlName="description"></ckeditor>
                                </div>
                            </div>
                            <div class="col-md-5 col-lg-5">
                                <div class="form-group">
                                    <label class="form-label">Full Description</label>
                                    <ckeditor [editor]="Editor" formControlName="full_description"></ckeditor>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <button type="submit" [disabled]="loading" class="btn btn-primary"><i *ngIf="loading"
                            class="fa fa-spin fa-spinner"></i>
                        <span *ngIf="!planId">Create Plan Package</span>
                        <span *ngIf="planId">Update Plan Package</span>
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>